import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { DataWizardAct, DocumentVM } from 'civil-status/view-models/step-form';
import { TYPE_DOCUMENT_PROCESSO_VERBALE } from 'civil-status/constants/type-document-processo-verbale';

export const transformDocumentEmergencyAct = (data: DataWizardAct): DocumentVM | undefined => {
  const castedResponseAllegati = data?.allegatoList || [];
  const filterAllegati = castedResponseAllegati?.filter(
    (item) => item.tipoAllegato === TYPE_DOCUMENT_PROCESSO_VERBALE
  );

  if (filterAllegati?.length === 0) {
    return {
      isSaved: false,
    };
  }

  const document: DocumentVM = {
    obligatoryFiles: [],
    isSaved: true,
  };

  filterAllegati.forEach((item) => {
    document.file = {
      tipoAllegato: item.tipoAllegato || '',
      name: item.nomeFile || '',
      idAllegato: item.key?.idAllegato || undefined,
      raw: item.oggettoAllegato || '',
      codStato: item.codStato || '',
    } as TypeFile;
  });

  return document;
};
